module.exports = __webpack_public_path__ + "static/img/kkrn_icon_onsei_1.09f8af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2026/kkrn_icon_onsei_1.png
// module id = 0MfC
// module chunks = 1